import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import Loading from 'components/App/Loading';
// import Bcoin from 'assets/images/Bcoin.svg';
import { convertIsoDateToString } from 'utils';

import styles from './CustomerGiftTable.module.scss';

function CustomerGiftTable({ data, loading }) {
  const giftsList = React.useMemo(
    () => (Array.isArray(data) ? data : []),
    [data],
  );

  return (
    <div className={styles.Component}>
      <Loading loading={loading} loaderOnPage />

      <Table responsive className="Table">
        <thead className="Table__Header">
          <tr className="Table__Header__Row">
            <th className="Table__Header__Row__Content">Mã giao dịch</th>
            <th className="Table__Header__Row__Content">Quà tặng</th>
            <th className="Table__Header__Row__Content">Giá xu</th>
            <th className="Table__Header__Row__Content">Thời gian đổi</th>
          </tr>
        </thead>

        <tbody className="Table__Body">
          {giftsList.map((item) => (
            <tr className="Table__Body__Row" key={item._id}>
              <td className="Table__Body__Row__Content transaction-id">
                {`#${item.gift?.giftId}`}
              </td>
              <td className="Table__Body__Row__Content gift-name">
                {item.gift?.name || 'Quà tặng'}
              </td>
              <td className="Table__Body__Row__Content coin-cell">
                <div className="d-flex align-items-center gap-1">
                  {/* <img src={Bcoin} alt="bcoin" /> */}
                  <span>
                    {(item.coin ?? item.gift?.coin ?? 0).toLocaleString(
                      'vi-VN',
                    )}
                    {' '}
                    xu
                  </span>
                </div>
              </td>
              <td className="Table__Body__Row__Content exchange-date">
                {convertIsoDateToString(item.createdAt)}
              </td>
            </tr>
          ))}

          {giftsList.length === 0 && (
            <tr>
              <td colSpan="4" className="text-center py-4 text-muted">
                Không có dữ liệu
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}

CustomerGiftTable.propTypes = {
  data: PropTypes.instanceOf(Array),
  loading: PropTypes.bool,
};

CustomerGiftTable.defaultProps = {
  data: [],
  loading: false,
};

export default CustomerGiftTable;
